import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMaterialdesigniconsComponent } from './simple-icons-materialdesignicons.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMaterialdesigniconsComponent ],
    exports:      [ SimpleIconsMaterialdesigniconsComponent ],
    bootstrap:    []
})
export class SimpleIconsMaterialdesigniconsModule {}
